import React, { useEffect, useState } from "react";
import { Box, Group, Text, Table } from "@mantine/core";
import { useLocation } from "react-router-dom";
import "../../styles/quotation-print.css";
import ApiLinks from "../../Navlinks/ApiLinks";
import api from "../../Utilities/Api";

function QuotationPrint() {
  const { state } = useLocation();
  const initialData = state?.data;
  const [data, setData] = useState(null);
  const [party, setParty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [itemsMap, setItemsMap] = useState({});


  useEffect(() => {
    const fetchData = async () => {
      try {
        const [quotationRes, itemsRes] = await Promise.all([
          api.get(
            `${process.env.REACT_APP_API_URL}/${ApiLinks.Quotation_GetById}/${initialData.vNo}/${initialData.finYear}`
          ),
          api.get(`${process.env.REACT_APP_API_URL}/${ApiLinks.Item}`)
        ]);

        if (itemsRes.data.status) {
          const map = {};
          itemsRes.data.data.forEach(it => {
            map[it.itemId] = it.itemName;
          });
          setItemsMap(map);
        }

        if (quotationRes.data.status) {
          const fetched = Array.isArray(quotationRes.data.data)
            ? quotationRes.data.data[0]
            : quotationRes.data.data;

          setData(fetched);

          if (fetched.partyId) {
            const partyRes = await api.get(
              `${process.env.REACT_APP_API_URL}/${ApiLinks.Party_GetById}/${fetched.partyId}`
            );

            if (partyRes.data.status) {
              const p = Array.isArray(partyRes.data.data)
                ? partyRes.data.data[0]
                : partyRes.data.data;

              setParty(p);
            }
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
        setTimeout(() => window.print(), 1200);
      }
    };


    fetchData();
  }, []);

  if (loading) return <Text>Loading…</Text>;
  if (!data) return <Text>No quotation found</Text>;

  const items = data.quotationLedger || [];

  const totalAmount = items.reduce((sum, i) => sum + Number(i.amount || 0), 0);

  return (
    <div className="print-wrapper">
      <img
        className="print-letterhead"
        src={`${process.env.PUBLIC_URL}/letter_head.png`}
        alt=""
        aria-hidden="true"
      />

      <Box className="content-area">


        <Box mb="xs" style={{ display: "flex", justifyContent: "space-between" }}>
          <Text>Quotation No: {data.vNo}</Text>
          <Text>Date: {new Date(data.vDate).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}</Text>
        </Box>

        {/* PARTY BLOCK */}
        <div
          className="party-block"
          dangerouslySetInnerHTML={{
            __html: (party?.partyName + "<br/>" + (party?.partyAddress || ""))
              .replace(/\n/g, "<br/>")
          }}
        />

        {/* SUBJECT */}
        <div
          dangerouslySetInnerHTML={{ __html: data.subject }}
        />


        {/* TABLE */}
        <table className="quot-table">
          <thead>
            <tr>
              <th className="amount-cell-th">Sr.</th>
              <th className="amount-cell-th">Description</th>
              <th className="amount-cell-th">Qty</th>
              <th className="amount-cell-th">Rate</th>
              <th className="amount-cell-th">Amount</th>
            </tr>
          </thead>

          <tbody>
            {items.map((row, idx) => (
              <tr key={idx}>
                <td className="amount-cell">{idx + 1}</td>
                <td>{itemsMap[row.itemId] || `Item ${row.itemId}`}</td>
                <td className="amount-cell">{row.qty}</td>
                <td className="amount-cell">
                  {row.rate.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                </td>
                <td className="amount-cell">
                  {row.amount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                </td>
              </tr>
            ))}
          </tbody>

          <tfoot>
            <tr className="grand-total-row">
              <td className="grand-total-label" colSpan={4}>Grand Total</td>
              <td className="amount-cell grand-total-value">
                {totalAmount.toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}
              </td>
            </tr>
          </tfoot>

        </table>

        {/* TERMS */}

        <div className="terms-wrapper">
          <div
            className="term-item"
            dangerouslySetInnerHTML={{ __html: (data.termsAndConditions || '').replace(/(<p>\s*(<br\s*\/?>\s*)*<\/p>\s*)+$/gi, '') }}
          />
        </div>
        <div className="safe-break"></div>

        <div
          className="footer-block "
          dangerouslySetInnerHTML={{ __html: data.footer }}
          style={{ whiteSpace: "pre-line" }}
        />

      </Box>
    </div>
  );
}

export default QuotationPrint;
